export const replaceKeys = (str: string, data: Record<string, any>) => {
  return Object.entries(data).reduce((acc: string, [key, value]) => acc.replaceAll(`{{${key}}}`, value), str);
};

export const capitalize = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
